import { SharedDetails } from '.';

export class SharedTradeDeatails {
  data: SharedDetails[] = [];
  recordsFiltered: number = 0;
  recordsTotal: number = 0;
}
